// Minimal markdown renderer for legal docs.
// Supports: ## headings, **bold**, *bullets*, paragraphs, blank lines.
// Intentionally simple — no external deps needed.

import React from "react";

function renderInline(text) {
  // Bold via **text**
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}

export default function MarkdownRender({ content }) {
  if (!content) return null;
  const lines = content.split("\n");
  const out = [];
  let buf = []; // current paragraph

  const flushPara = () => {
    if (buf.length) {
      out.push(
        <p key={`p-${out.length}`} className="text-ec-ink-soft leading-relaxed mt-4">
          {renderInline(buf.join(" "))}
        </p>
      );
      buf = [];
    }
  };

  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    const trimmed = line.trim();

    if (!trimmed) {
      flushPara();
      i += 1;
      continue;
    }
    if (trimmed.startsWith("## ")) {
      flushPara();
      out.push(
        <h2 key={`h2-${out.length}`} className="font-display text-xl sm:text-2xl font-black tracking-tight mt-10 first:mt-0 text-ec-ink">
          {trimmed.slice(3)}
        </h2>
      );
      i += 1;
      continue;
    }
    if (trimmed.startsWith("* ") || trimmed.startsWith("- ")) {
      flushPara();
      const items = [];
      while (i < lines.length && (lines[i].trim().startsWith("* ") || lines[i].trim().startsWith("- "))) {
        items.push(lines[i].trim().slice(2));
        i += 1;
      }
      out.push(
        <ul key={`ul-${out.length}`} className="mt-4 space-y-2 list-disc pl-6 text-ec-ink-soft">
          {items.map((it, k) => <li key={k}>{renderInline(it)}</li>)}
        </ul>
      );
      continue;
    }
    // regular line — accumulate into current paragraph
    buf.push(trimmed);
    i += 1;
  }
  flushPara();
  return <div className="legal-prose">{out}</div>;
}
